export default __webpack_public_path__ + "static/media/selamat3.3a7cf579.svg";